import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Option } from 'fp-ts/Option';

import { GeneralServiceDocumentType as ServiceDocumentType } from '@mews-distributor/data-access';

import { ApplicationState } from '../../../types';
import { localizeProperty } from '../../globalization/selectors';
import { getSelectedHotelId } from '../../resourceOrder/selectors';
import { getEnterpriseServiceId } from '../services/selectors';
import { getServiceTypeDocumentMarkdownValues } from './selectors';

interface GetSelectedEnterpriseDocumentMarkdownValueProps {
    type: ServiceDocumentType;
}

const getSelectedEnterpriseDocumentMarkdownValue = (
    state: ApplicationState,
    { type }: GetSelectedEnterpriseDocumentMarkdownValueProps
): Option<string> =>
    pipe(
        getSelectedHotelId(state),
        (enterpriseId) => getEnterpriseServiceId(state, { enterpriseId }),
        option.fromNullable,
        option.flatMap((serviceId) => getServiceTypeDocumentMarkdownValues(state, { serviceId, type })),
        option.map((property) => localizeProperty(state, { property }))
    );

const createGetSelectedEnterpriseDocumentMarkdownValue = (type: ServiceDocumentType) => (state: ApplicationState) =>
    getSelectedEnterpriseDocumentMarkdownValue(state, { type });

export const getSelectedEnterprisePrivacyPolicyMarkdownValue = createGetSelectedEnterpriseDocumentMarkdownValue(
    ServiceDocumentType.PrivacyPolicy
);
export const getSelectedEnterpriseTermsAndConditionsMarkdownValue = createGetSelectedEnterpriseDocumentMarkdownValue(
    ServiceDocumentType.TermsAndConditions
);
